import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types";

export const getAIGeneratedMapErrorCode = (state: RootState) => state.domains.createMap.AIGeneratedMapErrorCode;

export const getAIGeneratedMapProgress = (state: RootState) => state.domains.createMap.AIGeneratedMapProgress;

export const getCurrentMap = (state: RootState) => state.domains.createMap.data;

export const getCurrentMapIsNew = (state: RootState) => !state.domains.createMap.data?.id;

export const getCurrentCustomMapDescription = (state: RootState) => state.domains.createMap.description;

export const getLocalImage = (state: RootState) => state.domains.createMap.image;

export const getIsAIGeneratedMapFetching = (state: RootState) => state.domains.createMap.isAIGeneratedMapFetching;

export const getIsAIGeneratedModeOn = (state: RootState) => state.domains.createMap.isAIGeneratedModeOn;

export const getIsKeyIssuesDragging = (state: RootState) => state.domains.createMap.isDraggingKeyIssue;

export const getMapIsPending = (state: RootState) => state.domains.createMap.isPending;

export const getCurrentMapDimensionIds = (state: RootState) => state.domains.createMap.keyIssueIds;

export const getCurrentCustomMapName = (state: RootState) => state.domains.createMap.name;

export const getNewCustomDimensions = (state: RootState) => state.domains.createMap.newCustomKeyIssues;

export const getExistingDimensionIds = createSelector(
  getCurrentMapDimensionIds,
  getNewCustomDimensions,
  (dimensionIds, newCustomDimensions) =>
    dimensionIds.filter((id) => !newCustomDimensions.some((dimension) => dimension.id === id)),
);

export const getMapHasUnsavedChanges = (state: RootState) => {
  const map = getCurrentMap(state);
  const description = getCurrentCustomMapDescription(state);
  const localImage = getLocalImage(state);
  const name = getCurrentCustomMapName(state);
  const dimensionIds = getCurrentMapDimensionIds(state);

  const oldDimensionIds = map?.dimensionIds ?? [];
  const haveDimensionsChanged =
    dimensionIds.length !== oldDimensionIds.length || dimensionIds.some((id) => !oldDimensionIds.includes(id));

  return (
    map !== undefined &&
    (map.name !== name || map.description !== description || localImage !== undefined || haveDimensionsChanged)
  );
};

export const getCanUploadMap = (state: RootState) => {
  const isNew = getCurrentMapIsNew(state);
  const images = state.domains.createMap.data?.images;
  const image = getLocalImage(state);
  const dimensionIds = getCurrentMapDimensionIds(state);
  const name = getCurrentCustomMapName(state);

  const isNameValid = !!name;
  const isImagePresent = !!images || !!image;
  const isTopicExistingOrDoesLocalImageExist = !isNew || !!image;
  const doesTopicHaveDimensions = dimensionIds.length !== 0;

  return isNameValid && isImagePresent && isTopicExistingOrDoesLocalImageExist && doesTopicHaveDimensions;
};
